import { render, staticRenderFns } from "./Follower.vue?vue&type=template&id=b5ca148c"
import script from "./Follower.vue?vue&type=script&lang=js"
export * from "./Follower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports